/* Results Drawer */
document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.results_drawer_open');
  if (!trigger) return;

  const popupClass = trigger.getAttribute('popup_id');
  if (!popupClass) return;

  // close any open popup first (optional but recommended)
  document.querySelectorAll('.Ingredient_innerpart_innerloop_innerbox_inneritem_innerrow_mainpopup_new.open').forEach(el => el.classList.remove('open'));

  const target = document.querySelector(`.Ingredient_innerpart_innerloop_innerbox_inneritem_innerrow_mainpopup_new.${popupClass}`);
  if (!target) return;

  trigger.classList.add('active');
  target.classList.add('open');
  document.body.classList.add('results_drawer_is_open');
});

document.addEventListener('click', function (e) {
  const closeTrigger = e.target.closest('.results_drawer_overlay_new, .results_drawer_close');
  if (!closeTrigger) return;

  document.body.classList.remove('results_drawer_is_open');

  document.querySelectorAll('.results_drawer_open').forEach(el => el.classList.remove('active'));
  document.querySelectorAll('.Ingredient_innerpart_innerloop_innerbox_inneritem_innerrow_mainpopup_new.open').forEach(el => el.classList.remove('open'));
});
/* Results Drawer */

/* Show All Ingredients */
document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("click", function (e) {
        const mainPart = document.querySelector(".Ingredient_inneritem_mainpart_new");

        // Click on SHOW → activate HIDE + add open
        if (e.target.matches(".Ingredient_inneritem_show_new span")) {

            document.querySelectorAll(".Ingredient_inneritem_show_new span")
                .forEach(el => el.classList.remove("active"));

            document.querySelectorAll(".Ingredient_inneritem_hide_new span")
                .forEach(el => el.classList.add("active"));

            if (mainPart) mainPart.classList.add("open");
        }

        // Click on HIDE → activate SHOW + remove open
        if (e.target.matches(".Ingredient_inneritem_hide_new span")) {

            document.querySelectorAll(".Ingredient_inneritem_hide_new span")
                .forEach(el => el.classList.remove("active"));

            document.querySelectorAll(".Ingredient_inneritem_show_new span")
                .forEach(el => el.classList.add("active"));

            if (mainPart) mainPart.classList.remove("open");
        }
    });
});
/* Show All Ingredients */